window.app = window.app || {};

window.app.featuredVideos = {
  items: document.querySelectorAll('.mt-featured-videos__item'),

  isVideoPlaying: function(video) {
    return (video.currentTime > 0 && !video.paused && !video.ended && video.readyState > video.HAVE_CURRENT_DATA);
  },

  updateVideoSrc: function(item = null) {
    if (item === null) return;

    const video = item.querySelector('video');
    if (video.src === '') {
      video.src = video.dataset.src;
      video.load();
    }
    
    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(error => {
        if (error.name !== 'AbortError') {
          console.error('Video play error:', error);
        }
      });
    }
  },

  init: function () {
    const _this = this;
    if (_this.items.length == 0) return;

    _this.items.forEach(item => {
      const title = item.querySelector('.mt-featured-videos__item-title');
      const link = item.querySelector('.mt-featured-videos__item-link');
      const video = item.querySelector('video');
      video.addEventListener('play', () => item.classList.add('is-playing'));
      video.addEventListener('pause', () => item.classList.remove('is-playing'));

      item.addEventListener('mouseenter', () => {
        if (window.innerWidth >= 768) _this.updateVideoSrc(item);
      });
      item.addEventListener('mouseleave', () => {
        if (window.innerWidth >= 768) video.pause();
      }, { passive: true });

      item.addEventListener('click', e => {
        if (window.innerWidth < 768) {
          if (!_this.isVideoPlaying(video)) {
            _this.updateVideoSrc(item);
            _this.items.forEach(i => i !== item && i.querySelector('video').pause());
          } else {
            video.pause();
          }
        }
        if (title && e.target.nodeName !== 'A' && !e.target.closest('.mt-featured-videos__item-link')) {
          app.dl.customClick(title.innerText, { type: 'video', location: 'featured-videos-homepage' });
        }
      });
      if (title && link) {
        link.addEventListener('click', () => app.dl.ctaClick(title.innerText, { location: 'featured-videos-homepage' }));
      }
    });
  },
};
window.app.featuredVideos.init();